// packages
import { createFeed, createOfficeFeed } from './stores.js';
import {
  renderSvelteComponent,
  findSvelteComponentContainers,
} from './utils/render.js';

//components
import TwoColumnList from './components/TwoColumnList.svelte';

// URL for alpha and pub
import { STATE_URL } from './constants.js';

async function main() {
  const COMPONENT_TYPES = {
    'embeds-two-col-table': TwoColumnList,
    // etc.
  };

  const stateFeed = await createFeed(STATE_URL);

  Object.keys(COMPONENT_TYPES).forEach((componentType) => {
    // Select the svelte JS that this type needs to render
    const svelteScript = COMPONENT_TYPES[componentType];

    // Find them all and render them
    const elements = findSvelteComponentContainers(
      `[data-component-type="${componentType}"]`
    );

    if (elements.length) {
      elements.forEach((element) => {
        const office = element.dataset.office;
        const feed = /**  @type {import('./types.js').RaceFeed}  */ (
          createOfficeFeed(stateFeed, office)
        );

        renderSvelteComponent(
          svelteScript,
          /** @type {HTMLElement} */ element,
          { feed }
        );
      });
    }
  });
}

main().catch(console.error);
